// AnimatedBackground — fixed full-viewport background layer | scrolling dot grid only | glow is handled per-section

import React from "react";

const AnimatedBackground: React.FC = () => {
  return (
    <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none">
      {/* Base dark color */}
      <div className="absolute inset-0 bg-[#050508]" />

      {/* Scrolling dot grid — no glow here; each section owns its own glow */}
      <div
        className="absolute inset-x-0 top-0"
        style={{
          height: "200%",
          backgroundImage: "radial-gradient(circle, rgba(255, 255, 255, 0.15) 1.5px, transparent 1.5px)",
          backgroundSize: "32px 32px",
          animation: "scrollDots 100s linear infinite",
        }}
      />
    </div>
  );
};

export default AnimatedBackground;
